window.onload = function () {
    // to top btn
    if(document.querySelector('.btn-to-top')){
        let toTopBtn = document.querySelector('.btn-to-top');
        let timeOutScroll;

        function topBtnScroll() {
            if (pageYOffset >= document.documentElement.clientHeight) {
                toTopBtn.classList.add('active');
            } else {
                toTopBtn.classList.remove('active');
            }
        }

        window.addEventListener('scroll', topBtnScroll);

        function toTop() {
            let top = Math.max(document.body.scrollTop, document.documentElement.scrollTop);
            if (top > 0) {
                window.scrollBy(0, -100);
                timeOutScroll = setTimeout(toTop, 20);
            } else {
                clearTimeout(timeOutScroll);
            }
        }
        toTopBtn.addEventListener('click', toTop);
    }

    if(document.querySelector('.banner-swiper')){
        var banners = new Swiper('.banner-swiper', {
            spaceBetween: 1,
            loop: true,
            slidesPerView:1,
            loopedSlides: 1, //looped slides should be the same
            effect: 'fade',
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },

        });
    }

    function  accordion() {
        let accordionItem = document.querySelectorAll('.accordion-button');
        accordionItem.forEach(function (element) {
            console.log(element.nextElementSibling.scrollHeight);
            element.nextElementSibling.style.maxHeight = element.nextElementSibling.scrollHeight + "px";
            if(document.querySelector('.sidebar-filter-list .accordion-button')){
                document.querySelectorAll('.sidebar-filter-list .accordion-button').forEach(function (element) {
                    element.nextElementSibling.style.maxHeight = 0 +'px';
                    element.classList.add('active');
                })
            }
            element.addEventListener('click',function () {
                this.classList.toggle('active');
                if(this.classList.contains('active')){
                    this.nextElementSibling.style.maxHeight = 0;
                }
                else{
                    this.nextElementSibling.style.maxHeight = this.nextElementSibling.scrollHeight + "px";
                }
            });
        })
    };
    accordion();

    if ($(".filter-choosen").length) {
        // button reset all checkbox
        let resetCheckbox = document.querySelector('.filter-choosen__clear');
        let paramList = document.querySelector('.filter-choosen-list');
        resetCheckbox.onclick = function () {
            $(".container-checkbox input:checked").prop("checked", false);
            paramList.innerHTML = '';
            event.preventDefault();
        };

        //add param
        function paramChange() {
            let paramcheckbox = $('.container-checkbox input[type="checkbox"]:checked');
            let accam = '';
            let paramList = $('.filter-choosen-list');
            paramcheckbox.each(function (index, value) {
                let checkboxTitle = $(value).closest('.sidebar-characteristic').find('.sidebar-characteristic__title').text();
                let checkboxName = $(value).closest('.container-checkbox').find('.checkbox-name').text();
                let datafilter = $(value).closest('.container-checkbox').find('input').attr('data-filter-id');
                accam  += `<span class="filter-choosen-list__item" data-filter-id='${datafilter}'><span class="filter-choosen-list__item-icon"></span><span class="filter-choosen-list__item-name">${checkboxTitle}</span>:<span class="filter-choosen-list__item-content">${checkboxName}</span></span>`;
            });
            paramList.html(accam);
        };

        $(document).on('click', '.sidebar-characteristic input[type="checkbox"]', function(){
            paramChange();
        });

        //delete param
        $(document).on('click', '.filter-choosen .filter-choosen-list__item', function(){
            let id = $(this).attr('data-filter-id');
            $(`.sidebar-characteristic input[data-filter-id=${id}]`).prop("checked",false);
            paramChange();
        });

    };


    function hoverProductChange() {
        let productItem = document.querySelectorAll('.additional-images');
        let productItemPhoto = document.querySelectorAll('.product-list__item');
        productItemPhoto.forEach(function (element) {
            let srcString = element.querySelector('.product-list__img img').dataset.productSrc;
            let srcArray = srcString.split(';',2);
            element.addEventListener('mouseover',function () {
                element.querySelector('.product-list__img img').setAttribute('src',srcArray[1]);
            });
            element.addEventListener('mouseout',function () {
                element.querySelector('.product-list__img img').setAttribute('src',srcArray[0]);
            });
        });
        productItem.forEach(function (element) {
            element.querySelectorAll('.additional-images__item').forEach(function (element2) {
                let mainPhoto =  element2.closest('.product-list__item').querySelector('.product-list__img img');
                let mainPhotoSrc = mainPhoto.getAttribute('src');
                element2.addEventListener('mouseover',function (e) {
                    e.stopPropagation();
                    mainPhoto.setAttribute('src', element2.querySelector('img').getAttribute('src'));
                });
                element2.addEventListener('mouseout',function (e) {
                    e.stopPropagation();
                    mainPhoto.setAttribute('src',mainPhotoSrc);
                });
            })
        })
    }
    hoverProductChange();


    if(document.querySelector('.mobile-filters')){
        let sidebarFilter = document.querySelector('.sidebar-wrapper');
        let mobileFilters = document.querySelector('.mobile-filters');
        if(document.querySelector('.sidebar-wrapper__button-back')){
            let closeSidebarFilter = document.querySelector('.sidebar-wrapper__button-back');
            closeSidebarFilter.addEventListener('click',FunccloseSidebarFilter);
        }
        if(document.querySelector('.js-filter')){
            let openFilterSidebar = document.querySelector('.js-filter');
            openFilterSidebar.addEventListener('click',FuncOpenSidebarFilter);
            openFilterSidebar.addEventListener('click',function () {
                if(!sidebarFilter.classList.contains('open-filter')){
                    sidebarFilter.classList.add('open-filter');
                    mobileFilters.classList.add('open-filter');
                }else{
                    sidebarFilter.classList.remove('open-filter');
                    mobileFilters.classList.remove('open-filter');
                    FunccloseSidebarFilter()
                }
                if(sidebarFilter.classList.contains('open-catalog')){
                    sidebarFilter.classList.remove('open-catalog');
                    mobileFilters.classList.remove('open-catalog');
                }
            })
        }
        if(document.querySelector('.js-catalog')){
            let openFilterSidebar2 = document.querySelector('.js-catalog');
            openFilterSidebar2.addEventListener('click',FuncOpenSidebarFilter);
            openFilterSidebar2.addEventListener('click',function () {
                if(!sidebarFilter.classList.contains('open-catalog')){
                    sidebarFilter.classList.add('open-catalog');
                    mobileFilters.classList.add('open-catalog');
                }else{
                    sidebarFilter.classList.remove('open-catalog');
                    mobileFilters.classList.remove('open-catalog');
                    FunccloseSidebarFilter()
                }
                if(sidebarFilter.classList.contains('open-filter')){
                    sidebarFilter.classList.remove('open-filter')
                    mobileFilters.classList.remove('open-filter')
                }
            })
        }
        function FunccloseSidebarFilter(){
            sidebarFilter.classList.remove('open');
            document.querySelector('html').classList.remove('no-scroll');
            document.querySelector('body').classList.remove('no-scroll');
        };
        function FuncOpenSidebarFilter(){
            sidebarFilter.style.top = (mobileFilters.getBoundingClientRect().y) + mobileFilters.offsetHeight + 5 + `px`;
            sidebarFilter.style.paddingBottom = (mobileFilters.getBoundingClientRect().y) + mobileFilters.offsetHeight - 10 + `px`;
            sidebarFilter.classList.add('open');
            document.querySelector('html').classList.add('no-scroll');
            document.querySelector('body').classList.add('no-scroll');
        };
    }


    var galleryThumbs = new Swiper('.product-card-img-nav-wrapper', {
        spaceBetween: 10,
        slidesPerView: 6,
        // freeMode: true,
        draggable:false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
    });
    var galleryTop = new Swiper('.product-card-img-main-wrapper', {
        spaceBetween: 10,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
        },
        thumbs: {
            swiper: galleryThumbs
        }
    });

    var galleryThumbs = new Swiper('.additional-products-list', {
        spaceBetween: 15,
        slidesPerView: 9,
        // freeMode: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        breakpoints: {
            320: {
                slidesPerView: 2,
            },
            380: {
                slidesPerView:3,
            },
            450: {
                slidesPerView: 4,
            },
            610: {
                slidesPerView: 5,
            },
            720: {
                slidesPerView: 6,
            },
            900: {
                slidesPerView: 7,
            },
            1050: {
                slidesPerView: 8,
            },
            1250: {
                spaceBetween: 15,
                slidesPerView: 9,
            },
        }
    });
    const zoom = require('jquery-zoom/jquery.zoom.min');

    $('.zoom-element').zoom(); // add zoom


    if(document.querySelector('.js-more-text-btn')){
        function moreText() {
            let buttonMore = document.querySelectorAll('.js-more-text-btn');
            buttonMore.forEach(function (element) {
                element.addEventListener('click',function (e) {
                    e.preventDefault();
                    element.closest('.js-text-block').querySelectorAll('p').forEach((item)=>{
                        if(!item.classList.contains('open')){
                            item.classList.add('open');
                            element.innerText = 'Скрыть';
                        }
                        else{
                            item.classList.remove('open');
                            element.innerText = 'Подробнее';
                        }
                    })

                })
            })
        };
        moreText();
    }
    if(document.querySelector('.description-block')){
        function moreText() {
            let buttonMore = document.querySelectorAll('.description-block-open-btn');
            buttonMore.forEach(function (element) {
                element.addEventListener('click',function (e) {
                    e.preventDefault();
                    element.closest('.description-block').querySelectorAll('.description-block__item').forEach((item)=>{
                        if(!item.classList.contains('open')){
                            item.classList.add('open');
                            element.innerText = 'Скрыть';
                        }
                        else{
                            item.classList.remove('open');
                            element.innerText = 'Подробнее';
                        }
                    })

                })
            })
        };
        moreText();
    }

};
